import {
  FormElementProps,
  FormElementRenderProps,
  isValid,
} from "react-forms-state/src";
import { Checkbox, CheckboxProps } from "./checkbox";

export function ConnectedCheckbox({
  debug,
  flatModel,
  name,
  onChange,
  sideMutation,
  validation,
  value,
  ...inputProps
}: Omit<FormElementProps, "elementName"> & CheckboxProps) {
  return (
    <FormElementRenderProps
      debug={debug}
      elementName={name}
      flatModel={flatModel}
      sideMutation={sideMutation}
      validation={validation}
      onChange={onChange}
    >
      {({ onChange, validation, value: formValue }) => {
        return (
          <Checkbox
            {...inputProps}
            ref={inputProps.ref as any}
            isInvalid={!isValid(validation) || inputProps.isInvalid}
            isSelected={
              value
                ? JSON.stringify(formValue) === JSON.stringify(value)
                : !!formValue
            }
            value={value}
            onValueChange={(checked) => {
              onChange(value ? (checked ? value : checked) : checked);
              inputProps.onValueChange?.(value);
            }}
          />
        );
      }}
    </FormElementRenderProps>
  );
}

ConnectedCheckbox.displayName = "RecareUI.ConnectedCheckbox";
